import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import moment from 'moment';
import Modal from '../../../_ui/Modal/Modal';

export default function VoucherWaitingListChildInfoModal({ row, open, onClose, lang }) {
  const { t } = useTranslation();
  const info = row['_original'];
  return (
    <Modal open={open} onClose={onClose} title={t('waitingList_modalTitle')}>
      <DialogContent className="disable">
        <Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.kindergartenVoucherId ?? ''}
              label={t('waitingList_kindergartenVoucherQueueId')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={
                info?.createdAt
                  ? moment(info.createdAt).format('DD.MM.YYYY HH:mm:ss')
                  : ''
              }
              label={t('waitingList_receiveDate')}
              InputProps={{
                readOnly: true
              }}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.childIin ?? ''}
              label={t('waitingList_childIin')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={`${info?.childSurname || ''} ${info?.childName ||
              ''} ${info?.childMiddleName || ''}`}
              label={t('waitingList_childFullName')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={
                lang === 'ru'
                  ? info.queuedType?.ru_name
                  : info.queuedType?.kk_name
              }
              label={t('waitingList_queuedType')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={
                lang === 'ru'
                  ? info.appStatusWebStatus?.ru_name
                  : info.appStatusWebStatus?.kk_name
              }
              label={t('waitingList_status')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={lang === 'ru' ? info.queuedRegion?.ru_name : info.queuedRegion?.kk_name}
              label={t('waitingList_serviceProviderLocation')}
            />
          </Grid>
          <Grid item xs={12} md={12} style={{ marginBottom: '10px' }}>
            <TextField
              value={info?.serviceProviderBin ?? ''}
              label={t('waitingList_serviceProviderBin')}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Modal>
  );
}
